import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import TeamMemberProfileForm from "./TeamMemberProfileForm";
import {checkPermissionByKey}  from '../utils/checkPermissionByKey' 
import { useSelector } from "react-redux";

const TeamMemberProfileDetails = () => {
  const location = useLocation();
  const { member } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [isDeactivating, setIsDeactivating] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false); 
  const [updatedMember, setUpdatedMember] = useState(member); 
  const user = useSelector((state) =>state?.user );


  const handleDeactivate = () => {
    setShowModal(true);
  };

  const handleEditToggle = () => {
    setIsEditing(true); // Set editing mode to true
  };

  const handleActivate = async () => {
    setIsDeactivating(true);
    try {
      const request = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/specialist/activateprovider/${id}`
      );
      if (request.data.success) {
        toast.success(request.data.message);
        setTimeout(() => {
          navigate('/team-member');
        }, 3000);
      } else {
        toast.error('Could not activate user.');
        setIsDeactivating(false);
      }
    } catch (error) {
      toast.error("Network connection lost. Please check your connection and try again.");
      setIsDeactivating(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedMember({ ...updatedMember, [name]: value });
  };

  const handleConfirmDeactivate = async () => {
    setIsDeactivating(true);
    try {
      const request = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/specialist/deactivateprovider/${id}`
      );
      if (request.data.success) {
        toast.success(request.data.message);
        setTimeout(() => {
          navigate('/team-member');
        }, 3000);
      } else {
        toast.error('Could not deactivate user.');
        setIsDeactivating(false);
      }
    } catch (error) {
      toast.error("Network connection lost. Please check your connection and try again.");
      setIsDeactivating(false);
    }
    setShowModal(false);
  };

  return (
    <>
      {!isEditing ? (
      <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Team Member Profile</h2>
        <div style={styles.buttonContainer}>
        {checkPermissionByKey(user, "teamMembersManagement", "ActivateDeactivateTeamMember") && (
          member.isactive ? (
            <>
              <button
                style={styles.deactivateButton}
                onClick={handleDeactivate}
                disabled={isDeactivating}
              >
                {isDeactivating ? "Deactivate" : "Deactivate"}
              </button>
              <button style={styles.editButton} onClick={handleEditToggle}>Edit</button>
            </>
          ) : (
            <>
              <button
                style={styles.activateButton}
                onClick={handleActivate}
                disabled={isDeactivating}
              >
                  {isDeactivating ? "Activate" : "Activate"}
              </button>
              {/* <button style={styles.editButton} onClick={handleEditToggle}>Edit</button> */}
            </>
          )
        )}
        </div>
      </div>
      <div style={styles.infoContainer}>
        <div style={styles.infoRow}>
          <span style={styles.span}>ID</span>
          <span style={styles.span}>{String(member._id).padStart(4, '0')}</span>
        </div>
        <div style={styles.infoRow}>
          <span style={styles.span}>Status</span>
          <span style={styles.span}>{member.isactive ? "Active" : "Inactive"}</span>
        </div>
        <div style={styles.infoRow}>
          <span style={styles.span}>First Name</span>
          <span style={styles.span}>{member.firstname}</span>
        </div>
        <div style={styles.infoRow}>
          <span style={styles.span}>Last Name</span>
          <span style={styles.span}>{member.lastname}</span>
        </div>
        <div style={styles.infoRow}>
          <span style={styles.span}>Email</span>
          <span style={styles.span}>{member?.email}</span>
        </div>
        <div style={styles.infoRow}>
          <span style={styles.span}>Role</span>
          <span style={styles.span}>{member?.Role?.name}</span>
        </div>
      </div>

      {/* Modal Component */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContainer}>
            <p style={styles.modalText}>Are you sure you want to <br /> make the team member inactive?</p>
            <button
              style={styles.confirmButton}
              onClick={handleConfirmDeactivate}
              disabled={isDeactivating} 
            >
              {isDeactivating ? "Deactivating" : "Yes, deactivate"}
            </button>
            <button
              style={styles.cancelButton}
              onClick={handleCloseModal}
              disabled={isDeactivating} // Disable cancel button when deactivating
            >
              No, keep active
            </button>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
    ): (
      <>
      <TeamMemberProfileForm
      member={updatedMember}
      handleInputChange={handleInputChange}
      /> 
      </>
    )}
    </>
  );
};

const styles = {
  container: {
    width: "600px",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "#fff",
    fontFamily: "Poppins",
  },
  header: {
    backgroundColor: "#064260",
    padding: "20px 35px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 600,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  deactivateButton: {
    backgroundColor: "#FF0000",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
  activateButton: {
    backgroundColor: "#3ABF19",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
  editButton: {
    backgroundColor: "#27B99A",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
  infoContainer: {
    padding: "0",
    border: "0",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 35px",
    borderBottom: "1px solid #eee",
    fontSize: "1em",
  },
  span: {
    margin: 0,
    fontSize: "17px",
    fontWeight: 600,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: "#fff",
    padding: "35px 46px 55px 46px",
    borderRadius: "20px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "396px",
  },
  modalText: {
    fontSize: "20px",
    fontWeight: "700",
    wordWrap: "break-word",
    lineHeight: "1.5",
  },
  confirmButton: {
    color: "#064260",
    border: "none",
    padding: "10px 15px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
  },
  cancelButton: {
    color: "#064260",
    border: "none",
    padding: "10px 15px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
  },
};

export default TeamMemberProfileDetails;
